import { Injectable } from '@angular/core';
import {Restangular} from "ngx-restangular";

@Injectable()
export class AssignmentService {

  constructor(private restAngular: Restangular) {
  }

  public assignmentsCRUD() {
    return this.restAngular.all("assignments");
  }

  public assignmentsUD(id = 0) {
    let url = "assignments";
    if (id > 0) {
      url = url + "/" + id;
    }
    return this.restAngular.one(url);
  }

  public getAssignmentFormData(){
    return this.restAngular.one('getAssignmentFormData');
  }

  public allAssignment(){
    return this.restAngular.all('allAssignment');
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/assignment.service.ts